import { StripeProduct } from "../../api/util/stripe/stripe-secrets";

interface EnterpriseOffer {
    vendorLogo: string;
    vendorName: string;
    vendorKey: string;
    price?: {
        PRO?: { monthly: string; yearly: string };
        FUNNELS?: { monthly: string; yearly: string };
    };
    checks?: {
        email?: RegExp;
    };
}

type Offers = {
    [key in "c21" | "remax_de" | "quinzz" | "kw_de"]: EnterpriseOffer;
};

export const enterpriseVendors = ["c21", "remax_de", "quinzz", "kw_de"];

export const enterpriseOffers: Offers = {
    remax_de: {
        vendorLogo: "/logos/remax-germany.png",
        vendorName: "RE/MAX Germany",
        vendorKey: "remax_de",
        price: {
            PRO: {
                monthly: StripeProduct.PRO.MONTHLY_23Q4_ENTERPRISE,
                yearly: StripeProduct.PRO.YEARLY_23Q4_ENTERPRISE
            },
            FUNNELS: {
                monthly: "",
                yearly: ""
            }
        },
        checks: {
            email: /^[a-zA-Z0-9._%+-]+@remax\.de$/
        }
    },
    quinzz: {
        vendorLogo: "/logos/quinzz.png",
        vendorName: "Quinzz. GmbH",
        vendorKey: "quinzz",
        price: {
            PRO: {
                monthly: StripeProduct.PRO.MONTHLY_23Q4_ENTERPRISE,
                yearly: StripeProduct.PRO.YEARLY_23Q4_ENTERPRISE
            },
            FUNNELS: {
                monthly: "",
                yearly: ""
            }
        },
        checks: {
            email: /^[a-zA-Z0-9._%+-]+@quinzz\.de$/
        }
    },
    kw_de: {
        vendorLogo: "/logos/kw-de.jpg",
        vendorName: "Keller Williams Germany",
        vendorKey: "kw_de",
        price: {
            PRO: {
                monthly: StripeProduct.PRO.MONTHLY_23Q4_ENTERPRISE,
                yearly: StripeProduct.PRO.YEARLY_23Q4_ENTERPRISE
            },
            FUNNELS: {
                monthly: "",
                yearly: ""
            }
        }
    },
    c21: undefined
};

export const checkOfferEmail = (email: string, offer: string) => {
    if (!offer || !enterpriseVendors.includes(offer)) return false;
    return new RegExp(enterpriseOffers[offer].checks.email, "g").test(email);
};
